function isNotNull(value) {
  return value !== null && value !== undefined;
}
function isFalsy(value) {
  return !isNotNull(value) || Number.isNaN(value) || value === '';
}

export { isFalsy, isNotNull };
